//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect } from 'react';

// === API ===
import { onProkeyAuditQC, requestProkeyAuditQC, removeListener } from 'api/prokey/prokey.websocket';

// === COMPONENTS ===
import { EditAuditQCDialog } from '../EditAuditQCDialog/EditAuditQCDialog';
import { DeleteAuditQCDialog } from '../DeleteAuditQCDialog/DeleteAuditQCDialog';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Box, 
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Tooltip,
  IconButton, 
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

//#endregion

//-----------------------------------------------------------------
export function AuditQCPanel() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();
  const [ fields , setFields ] = useState( [] );
  const [ selectedField, setSelectedField ] = useState(null) ;
  const [ showEditAuditQC , setShowEditAuditQC ] = useState( false );  
  const [ showDeleteAuditQC, setShowDeleteAuditQC ] = useState(false);
  
  //#endregion

  //#region [STYLES]

   const _styles = {
    table_auditqc: {
      width: '100%',
      height: '100%',
      borderRadius: '1rem',
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
    table_header_cell: {
      borderBottom: '2px solid ' + theme.palette.primary.main,
      color: theme.palette.primary.main,
    }
  }  
  
  const CONTAINER = {
    sx : _styles.container,
  }
  const TABLE_AUDIT_QC = {
    sx : _styles.table_auditqc,
    size : 'small',
  }

  //#endregion

  //#region [EFFECT] 

  useEffect(() => {
    //-----------------------------------------------------------------
    function handleProkeyAuditQC( data ) {
      //-----------------------------------------------------------------
      setFields( data );
    };
   
    onProkeyAuditQC( handleProkeyAuditQC );   

    requestProkeyAuditQC();   
    
     return () => {
      removeListener( 'PROKEY-AUDIT-QC-REQUEST', handleProkeyAuditQC );     
    }
  }, []);

  //#endregion

  //#region [EVENTS]

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function displayHeaders() {
    //-----------------------------------------------------------------
    return (
      <TableHead>
        <TableRow>
          <TableCell sx={_styles.table_header_cell} >{ 'Tenant'            }</TableCell>
          <TableCell sx={_styles.table_header_cell} >{ 'Audit Mode'        }</TableCell>
          <TableCell sx={_styles.table_header_cell} >{ 'Audit Type'        }</TableCell>
          <TableCell sx={_styles.table_header_cell} >{ 'Field Name'        }</TableCell>
          <TableCell sx={_styles.table_header_cell} >{ 'Field Value'       }</TableCell>
          <TableCell sx={_styles.table_header_cell} >{ 'Audit Return Code' }</TableCell>
          <TableCell sx={_styles.table_header_cell} >{ 'Audit Frequency'   }</TableCell>
          <TableCell sx={_styles.table_header_cell} >{ 'Audit Count'       }</TableCell>
          <TableCell sx={_styles.table_header_cell} >{ ' '                  }</TableCell>
        </TableRow>
      </TableHead>
    );
  }
  
  //-----------------------------------------------------------------
  function displayFields() {
    //-----------------------------------------------------------------
  if (!fields) return null;
    return(
      <TableBody sx={{width:'100'}}>
        {fields.map((field)=>(
          <TableRow key ={field.Id} id= {field.Id} >        
            <TableCell key={1} >{ field.Tenant }          </TableCell>
            <TableCell key={2} >{ field.AuditMode }       </TableCell>
            <TableCell key={3} >{ field.AuditType }       </TableCell>
            <TableCell key={4} >{ field.FieldName }       </TableCell>
            <TableCell key={5} >{ field.FieldValue }      </TableCell>
            <TableCell key={6} >{ field.AuditReturnCode } </TableCell>
            <TableCell key={7} >{ field.AuditFrequency }  </TableCell>
            <TableCell key={8} >{ field.AuditCount }      </TableCell>
            <TableCell >     
              {selectedField && (     
                <EditAuditQCDialog
                  key={selectedField.Id}
                  showDialog={showEditAuditQC}
                  setShowDialog={setShowEditAuditQC}
                  field={selectedField}                
                />
              )}
                <Tooltip title='Edit Table'>
                  <IconButton
                    aria-label='edit-table'
                    aria-controls='edit-table'
                    color='primary'
                    onClick={ () => { setSelectedField(field); setShowEditAuditQC(true) }} 
                    name='edit_audit_qc_table_btn'
                  >
                    <EditIcon fontSize='small'/>
                  </IconButton>
                </Tooltip>
              {selectedField && (     
              <DeleteAuditQCDialog
                key={selectedField.Id}
                showDeleteDialog={showDeleteAuditQC}
                setShowDeleteDialog={setShowDeleteAuditQC}
                field={selectedField}                
              />
            )}
              <Tooltip title='Delete Entry'>
                <IconButton
                  aria-label='edit-table'
                  aria-controls='edit-table'
                  color='primary'
                  onClick={ () => { setSelectedField(field); setShowDeleteAuditQC(true) }} 
                  name='delete_audit_qc_entry_btn'
                >
                  <DeleteForeverIcon fontSize='small'/>
                </IconButton>
              </Tooltip> 
            </TableCell>
          </TableRow>       
        ))}
      </TableBody>
    );   
  }

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box { ...CONTAINER } >       
        <Box sx={{ height: '100%' }}>
          <Table { ...TABLE_AUDIT_QC } >
            {displayHeaders()}
            {displayFields()}
          </Table>
        </Box>          
      </Box>
    );
  }

 
  //#endregion

  return display();
}